import { defineMessages } from 'react-intl';

import { defaultI18nMessage } from 'dc/i18n/MessageUtils';

export const nextAuthenticationMessage = (name, message) => {
    return defaultI18nMessage('nextAuthentication', name, message);
}

export const nextAuthenticationMessages = defineMessages({
    signInContainerPageTitle: nextAuthenticationMessage('signInContainerPageTitle', 'NEXT OTP'),
    signInContainerSubHeader: nextAuthenticationMessage('signInContainerSubHeader', 'NEXT OTP'),
    signInContainerForgotPasswordLinkLabel: nextAuthenticationMessage('signInContainerForgotPasswordLinkLabel', 'Forgot password?'),
    signInContainerForgotPasswordDialogTitle: nextAuthenticationMessage('signInContainerForgotPasswordDialogTitle', 'Reset your password'),
    signInContainerForgotPasswordDialogContentText: nextAuthenticationMessage('signInContainerForgotPasswordDialogContentText', 'Enter your email address and we will send you a link to reset your password.'),
    signInContainerDontHaveAnAccountText: nextAuthenticationMessage('signInContainerDontHaveAnAccountText', 'Don\'t have an account?'),
    signInContainerSignUpLinkLabel: nextAuthenticationMessage('signInContainerSignUpLinkLabel', 'Sign up'),
})